<script setup lang="ts">
  import HomeIcon from '~/assets/Icons/HomeIcon.vue';
  import ReportIcon from '~/assets/Icons/ReportIcon.vue';
  import ChartIcon from '~/assets/Icons/ChartIcon.vue';
  import VideoIcon from '~/assets/Icons/VideoIcon.vue';

  const router = useRouter();
  const props = defineProps<{
    active: 'dashboard' | 'reports' | 'home' | 'linkedin' | 'tutorial';
    hideDashboardReports?: boolean;
    hideTutorialLinkedin?: boolean;
  }>();

  const emit = defineEmits(['toggle', 'home', 'linkedin', 'tutorial']);

  const goHome = () => {
    router.push('/');
    emit('home');
  };

  const toggleSidebar = (type: 'dashboard' | 'reports') => {
    emit('toggle', type);
  };

  const openVideo = () => {
    emit('tutorial');
    window.open('/tutorial', '_blank');
  };

  const openLinkedIn = () => {
    emit('linkedin');
    window.open('https://www.linkedin.com/company/erp4imapct-com/', '_blank');
  };
</script>

<template>
  <div
    class="w-[60px] border-r border-zinc-200 flex flex-col items-center py-4 gap-4 bg-white z-50 h-[calc(100vh-56px)]"
  >
    <div class="flex flex-col items-center gap-4 border-b border-zinc-400 pb-2">
      <button
        class="p-2 rounded-lg"
        :class="props.active === 'home' ? 'bg-blue-100 text-blue-600' : 'hover:bg-zinc-100'"
        :title="'Home'"
        @click="goHome"
      >
        <HomeIcon class="w-5 h-5" />
      </button>

      <template v-if="!props.hideDashboardReports">
        <button
          class="p-2 rounded-lg"
          :class="props.active === 'dashboard' ? 'bg-blue-100 text-blue-600' : 'hover:bg-zinc-100'"
          :title="'Dashboard'"
          @click="toggleSidebar('dashboard')"
        >
          <ChartIcon class="w-5 h-5" />
        </button>

        <button
          class="p-2 rounded-lg"
          :class="props.active === 'reports' ? 'bg-blue-100 text-blue-600' : 'hover:bg-zinc-100'"
          :title="'Reports'"
          @click="toggleSidebar('reports')"
        >
          <ReportIcon class="w-5 h-5" />
        </button>
      </template>
    </div>
    <div
      v-if="!props.hideTutorialLinkedin"
      class="flex flex-col items-center gap-4 mt-auto border-t border-zinc-400 pt-2"
    >
      <button
        class="p-2 rounded-lg"
        :class="props.active === 'tutorial' ? 'bg-blue-100 text-blue-600' : 'hover:bg-zinc-100'"
        :title="'Tutorial'"
        @click="openVideo"
      >
        <VideoIcon class="w-5 h-5" />
      </button>

      <button
        class="p-2 rounded-lg"
        :class="props.active === 'linkedin' ? 'bg-blue-100 text-blue-600' : 'hover:bg-zinc-100'"
        :title="'Visit LinkedIn'"
        @click="openLinkedIn"
      >
        <FontAwesomeIcon :icon="['fab', 'linkedin']" class="w-5 h-5" :style="{ color: '#0077b5' }" />
      </button>
    </div>
  </div>
</template>
